import { useEffect, useState } from "react";
import { toast } from "sonner";
import { Dialog, DialogContent, DialogTitle, DialogDescription } from "../ui/dialog";
import { adminShop, errMsg } from "../../lib/shopApi";
import { btn } from "./shared";

export const PrintfulImportDialog = ({ open, onOpenChange, passcode, onImported }) => {
  const [list, setList] = useState(null);
  const [busyId, setBusyId] = useState(null);

  useEffect(() => {
    if (!open) return;
    setList(null);
    adminShop.printfulProducts(passcode).then(setList).catch((e) => { toast.error(errMsg(e)); setList([]); });
  }, [open, passcode]);

  const doImport = async (p) => {
    setBusyId(p.id);
    try {
      await adminShop.importPrintful(p.id, passcode);
      toast(p.imported ? `${p.name} refreshed from Printful.` : `${p.name} imported as a hidden draft.`);
      setList((l) => l.map((x) => (x.id === p.id ? { ...x, imported: true } : x)));
      onImported();
    } catch (e) { toast.error(errMsg(e)); }
    finally { setBusyId(null); }
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-2xl bg-[#F9F6F0] max-h-[85vh] overflow-y-auto" data-testid="printful-import-dialog">
        <DialogTitle className="font-display text-2xl text-[#4B3A2F]">Your Printful products</DialogTitle>
        <DialogDescription className="text-sm text-[#6D5A50]">
          Designs, sizes, colors and print placements stay exactly as you set them in Printful. Imported products start as hidden drafts.
        </DialogDescription>
        {!list && <p className="text-sm text-[#6D5A50]">Loading from Printful…</p>}
        {list && !list.length && <p className="text-sm text-[#6D5A50]" data-testid="printful-import-empty">No products found in your Printful store yet.</p>}
        <ul className="divide-y divide-[#E7DFD5]">
          {(list || []).map((p) => (
            <li key={p.id} className="flex items-center gap-4 py-3" data-testid={`printful-import-row-${p.id}`}>
              <div className="w-14 h-14 rounded bg-white border border-[#E7DFD5] overflow-hidden">
                {p.thumbnail && <img src={p.thumbnail} alt="" className="w-full h-full object-contain" />}
              </div>
              <div className="flex-1">
                <p className="font-display text-lg text-[#4B3A2F]">{p.name}</p>
                <p className="text-xs text-[#6D5A50]">{p.variants} options{p.imported ? " · already in your shop" : ""}</p>
              </div>
              <button type="button" className={p.imported ? btn.ghost : btn.primary} disabled={busyId === p.id} onClick={() => doImport(p)} data-testid={`printful-import-btn-${p.id}`}>
                {busyId === p.id ? "Working…" : p.imported ? "Refresh" : "Import"}
              </button>
            </li>
          ))}
        </ul>
      </DialogContent>
    </Dialog>
  );
};
